export default __webpack_public_path__ + "static/media/small-logon.d61565a7.png";